import { FieldValues } from 'react-hook-form';
import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import {
  SendingPlatform,
  ServiceProvidersBySendingPlatform,
  SERVICE_PROVIDER_NAMES,
} from '../constants';
import { CreateEspAccountPayload } from '../types';

export const createSparkpostPayload = (values: FieldValues) => {
  const { apiEndpoint, ...rest } = values;
  /**
   * Remove apiEndpoint from the payload if the account type is not Sparkpost Elite,
   * in case the user has entered a value for apiEndpoint but then changed the account type.
   */
  return values.esp === SERVICE_PROVIDERS.SPARKPOST_ELITE ? { ...rest, apiEndpoint } : rest;
};

export const createIterableSmsPayload = (values: FieldValues) => {
  const { apiEndpoint, ...rest } = values;
  const payload = rest as CreateEspAccountPayload;
  /**
   * apiEndpoint is editable for both Telnyx and Twilio ESP options, but only
   * relevant for Twilio.
   */
  if (apiEndpoint) payload.apiEndpoint = apiEndpoint;
  return { ...payload, isSenderIterable: true };
};

export const getEspRadioOptionsForSendingPlatform = (
  sendingPlatform: SendingPlatform,
  espDefinitions: SERVICE_PROVIDERS[],
  preselectedEsp?: SERVICE_PROVIDERS,
) =>
  ServiceProvidersBySendingPlatform[sendingPlatform]
    /** Only show ESP options that are returned from ESP Definitions query */
    .filter((esp) => espDefinitions.includes(esp))
    .map((esp) => ({
      id: esp,
      name: SERVICE_PROVIDER_NAMES[esp as keyof typeof SERVICE_PROVIDER_NAMES],
      value: esp,
    }))
    /**
     * In Edit forms, the ESP is already pre-selected and cannot be changed.
     * This disables all other ESP options in the radio list.
     */
    .map((option) =>
      preselectedEsp && option.value !== preselectedEsp
        ? {
            ...option,
            isDisabled: true,
          }
        : option,
    );
